import { Grid3x3 } from "lucide-react";
import type { LineageNode } from "../types";
import { NodeShell } from "./NodeShell";

interface Props {
  data: LineageNode;
  selected?: boolean;
}

export function AssessmentMatrixNode({ data, selected }: Props) {
  return <NodeShell node={data} icon={Grid3x3} selected={selected} />;
}
